
import { 
    UPDATE_USER_PROFILE,
    UP_USER_LOADING, 
    UPDATE_ERROR,
    GET_USER_PROFILE
} from './Constants';

const initialState = {
    isUploading: false,
    updateSucces: false,
    updateError: false,
    callback: '',
    nom: '',
    prenoms:'',
    contact:'',
    profession:'',
    residence:'',
    genre:'',
    date_naissance:'',
    fileUrl: null,
    accessFilters: {
        planIds: [],
        folderIds: [],
        maxConfidentialite: '',
        allowExport: true
    },
    serviceUnit: null
}

const getFile = file =>{
let userprofile = file;
if(file === null){
userprofile = '/digitalressources/user.png'
}
return {
    fileUrl: userprofile
}
}

export const UserDataSettings = (state = initialState, action) =>{
    switch (action.type) {
    case UP_USER_LOADING:
        return{
            ...state,
            isUploading: true
        }
    case UPDATE_ERROR:
        return{
            ...state,
            isUploading: false,
            updateError: true,
            callback: action.payload
        }
    case UPDATE_USER_PROFILE:
        return {
            ...state,
            isUploading: false,
            updateSucces: true
        }
        case GET_USER_PROFILE: {
            //const file = getFile(action.payload.fileUrl)
            const incomingFilters = action.payload.accessFilters || {}
            return {
                ...state,
                nom: action.payload.nom,
                prenoms: action.payload.prenoms,
                contact: action.payload.contact,
                profession: action.payload.profession,
                fileUrl: action.payload.fileUrl,
                accessFilters: {
                    planIds: Array.isArray(incomingFilters.planIds) ? incomingFilters.planIds : [],
                    folderIds: Array.isArray(incomingFilters.folderIds) ? incomingFilters.folderIds : [],
                    maxConfidentialite: incomingFilters.maxConfidentialite || '',
                    allowExport: incomingFilters.allowExport !== false
                },
                serviceUnit: action.payload.serviceUnit || null
            }
        }
    //Defaul value
    default:
        return state
    
    }
}
